<script setup lang="ts">
import Icon from '~/assets/images/icons/close.svg'

type Size = 16 | 18

type Props = {
  size?: Size
}

const props = withDefaults(defineProps<Props>(), {
  size: 18,
})
</script>

<template>
  <div class="icon-wrapper">
    <Icon :height="props.size" :width="props.size" />
  </div>
</template>

<style lang="scss" scoped>
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
